import type { UserRole } from '../data/app-adapter'

export type RouteAccess = 'public' | 'authenticated' | 'manager'

export const managerRoles = new Set<UserRole>(['manager_l1', 'manager_l2', 'area_supervisor'])

export function canAccess(access: RouteAccess, role: UserRole | null): boolean {
  if (access === 'public') return true
  if (!role) return false
  if (access === 'manager') return managerRoles.has(role)
  return true
}

function matchesRoutePattern(pattern: string, target: string): boolean {
  const targetPath = target.split(/[?#]/, 1)[0]
  const patternSegments = pattern.split('/').filter(Boolean)
  const targetSegments = targetPath.split('/').filter(Boolean)
  return patternSegments.length === targetSegments.length
    && patternSegments.every((segment, index) => segment.startsWith(':') || segment === targetSegments[index])
}

export const routeCatalog = [
  { path: '/login', label: '登入', access: 'public' },
  { path: '/home', label: '首頁', access: 'authenticated' },
  { path: '/growth', label: '成長任務', access: 'authenticated' },
  { path: '/training/:moduleId', label: '訓練詳情', access: 'authenticated' },
  { path: '/training/:moduleId/exam', label: '學科考試', access: 'authenticated' },
  { path: '/training/:moduleId/teaching', label: '帶教 Checklist', access: 'authenticated' },
  { path: '/training/:moduleId/results', label: '訓練成果', access: 'authenticated' },
  { path: '/garden', label: '家園', access: 'authenticated' },
  { path: '/thanks', label: '感謝', access: 'authenticated' },
  { path: '/thanks/activity', label: '感謝動態', access: 'authenticated' },
  { path: '/badges', label: '勳章', access: 'authenticated' },
  { path: '/badges/:badgeId', label: '勳章詳情', access: 'authenticated' },
  { path: '/functions', label: '功能中心', access: 'authenticated' },
  { path: '/notifications', label: '通知中心', access: 'authenticated' },
  { path: '/broadcasts/:announcementId', label: '系統廣播', access: 'authenticated' },
  { path: '/documents', label: '文件中心', access: 'authenticated' },
  { path: '/knowledge', label: 'VASO 智庫', access: 'authenticated' },
  { path: '/promotion', label: '升遷申請', access: 'authenticated' },
  { path: '/manager', label: '管理者中心', access: 'manager' },
  { path: '/account', label: '帳號設定', access: 'authenticated' },
] as const satisfies ReadonlyArray<{ path: string; label: string; access: RouteAccess }>

export function routeAccessFor(target: string): RouteAccess | null {
  return routeCatalog.find((route) => matchesRoutePattern(route.path, target))?.access ?? null
}
